<template>
   <div class="right">
      <div class="title-box">
        <span class="curr">分会专家</span>
      </div>
      <div class="list">
        <div class="item flexH" v-for="(item, index) in list" :key="index">
          <img :src="item.imageUrl" alt="">
          <div>
            <h3 class="name">{{item.name}}</h3>
<!--            <p class="flexHC job"><span class="mr-15">中国服贸会技术服务委员会</span>执行主任</p>-->
            <p class="desc mb-10">{{item.introduce}}</p>
          </div>
        </div>
      </div>
   </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          name: '李晓林',
          introduce: '经济学博士，教授，中国保险学会副会长、中央财经大学保险学院院长、保险与风险管理国际联合创新实验中心主任、全国保险专业学位研究生教育指导委员会秘书长；保险学和精算学博士研究生导师，保险与风险管理国际联合创新实验中心主任，保险风险分析创新引智基地（国家111引智基地）主任；教育部人文社会科学重点研究基地中央财经大学中国精算研究院的创建者；中国互联网金融协会互联网保险专业委员会主任委员；中国保险行业协会多个专家委员会副主任委员；中国精算师协会理事；全国保险专业学位研究生教育指导委员会秘书长，英国精算师协会荣誉精算师；教育部人文社会科学重点研究基地学术委员会委员，多省、市政府社会保障首席专家。',
          imageUrl: require('@/assets/img/expert/li_xiao_lin.png')
        },
        {
          name: '范英',
          introduce: '北京航空航天大学经济管理学院院长、能源与环境政策研究中心主任。国际能源经济学会（IAEE）副主席，中国优选法统筹法与经济数学研究会副理事长、低碳发展管理专业委员会理事长、中国能源学会专家委员等获得国家杰出青年科学基金、中国科学院百人计划、百千万人才工程国家级人选、国务院政府特殊津贴等奖励。长期从事能源经济与管理的研究，研究领域包括能源经济系统分析、能源金融、碳排放权交易机制、能源与气候政策等。近年来主持国家自然科学基金重点项目、重大国际合作与交流项目、重大项目课题、国家科技支撑计划项目、中国科学院战略性先导科技专项、中荷合作重点项目，以及来自企业和国际组织的科研项目60余项。获得5项省部级自然科学奖或科学技术奖，以及中国科学院朱李月华优秀教师奖、中国科学院京区“巾帼建功”先进个人等奖励。',
          imageUrl: require('@/assets/img/expert/fan_ying.png')
        },
        {
          name: '赵尚梅',
          introduce: '北京航空航天大学经济管理学院教授、博士生导师、金融系主任、金融专业硕士教育中心主任；中国金融学年会理事、中国保险学会教育委员会委员、济南仲裁委员会仲裁员。',
          imageUrl: require('@/assets/img/expert/zhao_shang_mei.png')
        },
        {
          name: '刘春梅',
          introduce: '原北京市高级人民法院民二庭副庭长，中国国际经济贸易仲裁委员会仲裁员。1999年毕业于中国人民大学法学院，民商法专业博士；1999-2021年，北京市高级人民法院民二庭工作，审理公司、金融、涉外商事、仲裁司法审查等商事纠纷案件并从事相关调研工作，参与相关司法政策的调研论证工作；2022年，担任中国国际经济贸易仲裁委员会仲裁员。',
          imageUrl: require('@/assets/img/expert/liu_chun_mei.png')
        },
        {
          name: '鲜瑜',
          introduce: '米兰大学法哲学博士候选人（2010年）；荷兰伊拉斯姆斯鹿特丹大学国际法学硕士（2004年）；北京师范大学文学学士（1998年）。业务领域为企业并购、能源行业投融资、私募基金及海外基金的搭设及募集文件准备及境内外上市。',
          imageUrl: require('@/assets/img/expert/xian_yu.png')
        },
      ]
    }
  }
};
</script>
<style lang="less" scoped>

.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  .item {
    padding: 30px 0;
    border-bottom: 1px solid #f8f8fb;
    img {
      width: 160px;
      height: 224px;
      margin-right: 25px;
      flex-shrink: 0;
    }
    .name {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1B252C;
      line-height: 25px;
      margin-bottom: 12px;
    }
    .job {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1B252C;
      line-height: 28px;
      margin-bottom: 20px;
    }
    .desc {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5F5F6A;
      line-height: 28px;
    }
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
